export default class DeviceDetector {
    constructor() {
        this.deviceSize = null;
        this.detectWindowWidth();
        this.detectDeviceSize();
        this.eventDelegation();
    };

    eventDelegation() {
        window.addEventListener('resize', () => {
            this.detectWindowWidth();
            this.detectDeviceSize();
        });
    }

    detectWindowWidth() {
        this.windowWidth = window.innerWidth;
    };

    isXsScreen() {
        return this.windowWidth < DeviceDetector.widthXs;
    };

    isSmScreen() {
        return this.windowWidth < DeviceDetector.widthSm;
    };

    isMdScreen() {
        return this.windowWidth < DeviceDetector.widthMd;
    };

    isLgScreen() {
        return this.windowWidth >= DeviceDetector.widthMd;
    };

    detectDeviceSize() {
        if (this.isXsScreen()) {
            this.deviceSize = DeviceDetector.sizeXs;
        } else if (this.isSmScreen()) {
            this.deviceSize = DeviceDetector.sizeSm;
        } else if (this.isMdScreen()) {
            this.deviceSize = DeviceDetector.sizeMd;
        } else if (this.isLgScreen()) {
            this.deviceSize = DeviceDetector.sizeLg;
        }
    };

    getDeviceSize() {
        return this.deviceSize;
    }

    detectBrowser() {
        const ua = navigator.userAgent || navigator.vendor || window.opera;

        const isChrome = /chrome|chromium|crios/i.test(ua) && !/edg/i.test(ua);
        const isFirefox = /firefox|fxios/i.test(ua);
        const isSafari = /safari/i.test(ua) && !/chrome|chromium|crios/i.test(ua);
        const isEdge = /edg/i.test(ua);
        const isOpera = /opera|opr/i.test(ua);
        const isIE = /msie|trident/i.test(ua);

        const isSamsungBrowser = /samsungbrowser/i.test(ua);
        const isUCBrowser = /ucbrowser/i.test(ua);

        if (isChrome) {
            return "Google Chrome";
        }
        if (isFirefox) {
            return "Mozilla Firefox";
        }
        if (isSafari) {
            return "Apple Safari";
        }
        if (isEdge) {
            return "Microsoft Edge";
        }
        if (isOpera) {
            return "Opera";
        }
        if (isIE) {
            return "Internet Explorer";
        }
        if (isSamsungBrowser) {
            return "Samsung Internet";
        }
        if (isUCBrowser) {
            return "UC Browser";
        }

        return "Unknown Browser";
    }

    isIPad() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const isIPad = /iPad/i.test(userAgent);
        const isMacIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
        return isIPad || isMacIPadOS;
    }
};


DeviceDetector.widthXs = 768;
DeviceDetector.widthSm = 992;
DeviceDetector.widthMd = 1200;
DeviceDetector.sizeXs = 'xs';
DeviceDetector.sizeSm = 'sm';
DeviceDetector.sizeMd = 'md';
DeviceDetector.sizeLg = 'lg';
